import { useCallback, useState } from 'react';
import {
  getAutoCompleteFilter,
  TicketDto,
  useInfiniteTicketsList,
} from '@sib/api';
import { ComboboxItem, ComboboxItemOption } from '@sib/ui';
import { useAutocompleteProps } from '../../hooks/use-autocomplete-props';
import { useDebouncedValue } from '../../hooks/use-debounced-value';

export const getTicketNumberLabel = (
  ticket: Pick<TicketDto, 'ticketNumber' | 'vectorTicketId'>
): string | null => {
  const value = ticket.ticketNumber ?? ticket.vectorTicketId;

  if (value == null || value === '') return null;

  return String(value);
};

export interface UseTicketsAutocompletePropsOptions {
  additionalFields?: ComboboxItemOption[];
}

export const useTicketsAutocompleteProps = ({
  additionalFields,
}: UseTicketsAutocompletePropsOptions = {}) => {
  const [filter, setFilter] = useState('');
  const debouncedFilter = useDebouncedValue(filter);
  const apiFilter = getAutoCompleteFilter({
    searchTerm: debouncedFilter,
    sortByField: 'ticketNumber',
    filterByField: 'ticketNumber',
  });

  const params = useInfiniteTicketsList(apiFilter);

  const optionsMapper = useCallback(
    (ticket: TicketDto): ComboboxItemOption | null => {
      const label = getTicketNumberLabel(ticket);

      return ticket.id && label ? { label, value: ticket.id } : null;
    },
    []
  );

  return useAutocompleteProps({
    params,
    filter,
    setFilter,
    optionsMapper,
    additionalFields,
    OptionComponent: ComboboxItem,
  });
};
